export default __webpack_public_path__ + "static/media/UserScreenBlue.144aecd6.svg";